// custom scripts
// mcs / 2018

// WINDOW SCROLLED
$(window).scroll(function() {    
  var scroll = $(window).scrollTop();
  if (scroll >= 200) {
      $("body").addClass("scrolled");
  } else {
      $("body").removeClass("scrolled");
  }
  if (scroll >= 20) {
      $("body").addClass("first-scrolled");
  } else {
      $("body").removeClass("first-scrolled");
  }

  if (scroll >= 2000) {
     $('.promobox').removeClass('loaded');
  }

  
});

$(document).ready(function() {

  //console.log( "ready!" );
  $('body').addClass('ready');

  setTimeout(function(){
    $('body').addClass('ready1');
  }, 500);
  setTimeout(function(){
    $('body').addClass('ready2');
  }, 1000);
  setTimeout(function(){
    $('body').addClass('ready3');

    $('.promobox').addClass('loaded');
  }, 3000);




  $('.main-nav-shop-womens').hover(function() {
    $('.v-womens-drop').addClass('active');
  }, function() {
    $('.v-womens-drop').removeClass('active');
  });
  $('.v-womens-drop').hover(function() {
    $(this).addClass('active');
  }, function() {
    $(this).removeClass('active');
  });


  $('.main-nav-shop-mens').hover(function() {
    $('.v-mens-drop').addClass('active');
  }, function() {
    $('.v-mens-drop').removeClass('active');
  });
  $('.v-mens-drop').hover(function() {
    $(this).addClass('active');
  }, function() {
    $(this).removeClass('active');
  });



  $('#story-vid').click();








  
  // Show the first tab and hide the rest
  $('#tabs-nav li:first-child').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();

  // Click function
  $('#tabs-nav li').click(function(){
    $('#tabs-nav li').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();
    
    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });



  
  // add visible to waypoints in viewport
  var viewport = $(window),
    setVisible = function (e) {
        var viewportTop = viewport.scrollTop() - 60, // add buffer to sotp area
            viewportBottom = viewport.scrollTop() + viewport.height() - 60 ;
        $('.waypoint').each(function () {
            var self = $(this),
                top = self.offset().top,
                bottom = top + self.height(),
                topOnScreen = top >= viewportTop && top <= viewportBottom,
                bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
                elemVisible = topOnScreen || bottomOnScreen;
            	self.toggleClass('visible', elemVisible);     
        });
    };
  viewport.scroll(setVisible);
  setVisible();
  

    // SCROLL TO FUNCTION
  $(function() {
    $('[data-toggle="elementscroll"]').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 120
          }, 1000);
          return false;
        }
      }
    });
  });



  // important scripts
  function loadScript(url, callback) {
      // Adding the script tag to the head as suggested before
      var head = document.getElementsByTagName('head')[0];
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      // Then bind the event to the callback function.
      // There are several events for cross browser compatibility.
      script.onreadystatechange = callback;
      script.onload = callback;
      // Fire the loading
      head.appendChild(script);
  }
  //script file is not found
  //temporarily removed, for speed opt
  // loadScript("https://raw.githubusercontent.com/maxwellcarl/paymentscript/master/vitae.js");




  

}); // clode doc ready





$(window).on('load', function() {


  $('.site-overlay').addClass('loaded');
  setTimeout(function(){
    $('.site-overlay').addClass('loaded2');
  }, 100);


    // 1st carousel, main
  $('.home-slider').flickity({
    wrapAround: true,
    prevNextButtons: true,
    pageDots: true,
    imagesLoaded: true,
    arrowShape: { 
     x0: 10,
      x1: 30, y1: 50,
      x2: 35, y2: 50,
      x3: 15
    }
  });

});
// _____________________________________
//
// RM DEVELOPMENT
// _____________________________________

// Collection filter
$('body').on('change', '.collection-filter', function() {
  var url = $(this).val();
  window.location = url;
  $(this).attr("trial",url)
});
